import React from 'react';
import { useMetaTags } from '../hooks/useMetaTags';
export function TermsPage() {
  useMetaTags({
    title: 'Terms & Conditions | FindOnlineDegrees',
    description: 'Terms and conditions for using FindOnlineDegrees.org'
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-1620">
      {/* Hero Section */}
      <section className="w-full bg-[#1a2332] text-white py-16 px-4" data-id="element-1621">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1622">
          <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-1623">
            Terms & Conditions
          </h1>
          <p className="text-gray-300 text-sm" data-id="element-1624">Last updated: May 2026</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-4 py-12" data-id="element-1625">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12 space-y-8" data-id="element-1626">
          {/* Agreement to Terms */}
          <div data-id="element-1627">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1628">
              AGREEMENT TO TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1629">
              <p data-id="element-1630">
                These Terms of Use constitute a legally binding agreement
                between you and FindOnlineDegrees.org concerning your access to
                and use of the website. By accessing the site, you confirm that
                you have read, understood, and agree to be bound by these Terms
                of Use.{' '}
                <strong data-id="element-1631">
                  IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, YOU ARE
                  PROHIBITED FROM USING THE SITE AND MUST DISCONTINUE USE
                  IMMEDIATELY.
                </strong>
              </p>
              <p data-id="element-1632">
                We reserve the right to make changes or modifications to these
                Terms of Use at any time and for any reason. We will alert you
                to any changes by updating the "Last updated" date above. Your
                continued use of the site after revised terms are posted
                constitutes acceptance of the changes.
              </p>
              <p data-id="element-1633">
                The site is intended for users who are at least{' '}
                <strong data-id="element-1634">18 years</strong> old. Persons under 18 are not
                permitted to use or register for the site.
              </p>
            </div>
          </div>

          {/* Intellectual Property Rights */}
          <div data-id="element-1635">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1636">
              INTELLECTUAL PROPERTY RIGHTS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1637">
              <p data-id="element-1638">
                Unless otherwise indicated, the site is our proprietary
                property, and all source code, databases, functionality,
                software, website designs, audio, video, text, photographs, and
                graphics on the site are owned or controlled by us or licensed
                to us, and are protected by copyright and trademark laws.
              </p>
              <p data-id="element-1639">
                The content is provided <strong data-id="element-1640">"AS IS"</strong> for your
                information and personal use only. Except as expressly provided
                in these Terms of Use, no part of the site or content may be
                copied, reproduced, aggregated, republished, uploaded, posted,
                publicly displayed, encoded, translated, transmitted,
                distributed, sold, licensed, or otherwise exploited for any
                commercial purpose without our express prior written permission.
              </p>
              <p data-id="element-1641">
                You are granted a limited license to access and use the site and
                to download or print a copy of any portion of the content to
                which you have properly gained access solely for your{' '}
                <strong data-id="element-1642">personal, non-commercial use</strong>.
              </p>
            </div>
          </div>

          {/* User Representations */}
          <div data-id="element-1643">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1644">
              USER REPRESENTATIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1645">
              <p data-id="element-1646">By using the site, you represent and warrant that:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1647">
                <li data-id="element-1648">
                  All registration information you submit will be true,
                  accurate, current, and complete
                </li>
                <li data-id="element-1649">
                  You will maintain the accuracy of such information and
                  promptly update it as necessary
                </li>
                <li data-id="element-1650">
                  You have the legal capacity and agree to comply with these
                  Terms of Use
                </li>
                <li data-id="element-1651">
                  You are not a minor in the jurisdiction in which you reside
                </li>
                <li data-id="element-1652">
                  You will not access the site through automated or non-human
                  means
                </li>
                <li data-id="element-1653">
                  You will not use the site for any illegal or unauthorized
                  purpose
                </li>
                <li data-id="element-1654">
                  Your use of the site will not violate any applicable law or
                  regulation
                </li>
              </ul>
            </div>
          </div>

          {/* Prohibited Activities */}
          <div data-id="element-1655">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1656">
              PROHIBITED ACTIVITIES
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1657">
              <p data-id="element-1658">
                You may not access or use the site for any purpose other than
                that for which we make the site available. The site may not be
                used in connection with any commercial endeavors except those
                that are specifically endorsed or approved by us.
              </p>
              <p data-id="element-1659">As a user of the site, you agree not to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1660">
                <li data-id="element-1661">
                  Systematically retrieve data or other content from the site to
                  create a collection, compilation, database, or directory
                </li>
                <li data-id="element-1662">
                  Make any unauthorized use of the site, including collecting
                  usernames and/or email addresses by electronic or other means
                </li>
                <li data-id="element-1663">
                  Use the site to advertise or offer to sell goods and services
                </li>
                <li data-id="element-1664">
                  Circumvent, disable, or otherwise interfere with
                  security-related features of the site
                </li>
                <li data-id="element-1665">
                  Engage in unauthorized framing of or linking to the site
                </li>
                <li data-id="element-1666">Trick, defraud, or mislead us and other users</li>
                <li data-id="element-1667">
                  Interfere with, disrupt, or create an undue burden on the site
                  or the networks or services connected to the site
                </li>
                <li data-id="element-1668">Attempt to impersonate another user or person</li>
                <li data-id="element-1669">
                  Use any information obtained from the site to harass, abuse,
                  or harm another person
                </li>
                <li data-id="element-1670">
                  Use the site in a manner inconsistent with any applicable laws
                  or regulations
                </li>
              </ul>
            </div>
          </div>

          {/* User Generated Contributions */}
          <div data-id="element-1671">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1672">
              USER GENERATED CONTRIBUTIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1673">
              <p data-id="element-1674">
                The site may invite you to chat, contribute to, or participate
                in blogs, message boards, online forums, and other
                functionality. Any content you transmit to the site will be
                treated as non-confidential and non-proprietary.
              </p>
              <p data-id="element-1675">
                By posting content to the site, you grant us an unrestricted,
                unlimited, irrevocable, perpetual, non-exclusive, transferable,
                royalty-free, fully-paid, worldwide right to use, copy,
                reproduce, distribute, and display such content.
              </p>
            </div>
          </div>

          {/* Submissions */}
          <div data-id="element-1676">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1677">
              SUBMISSIONS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1678">
              <p data-id="element-1679">
                You acknowledge and agree that any questions, comments,
                suggestions, ideas, feedback, or other information regarding the
                site provided by you to us are non-confidential and shall become
                our sole property. We shall own exclusive rights, including all
                intellectual property rights, and shall be entitled to the
                unrestricted use and dissemination of these submissions for any
                lawful purpose, commercial or otherwise, without acknowledgment
                or compensation to you.
              </p>
            </div>
          </div>

          {/* Site Management */}
          <div data-id="element-1680">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1681">
              SITE MANAGEMENT
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1682">
              <p data-id="element-1683">We reserve the right, but not the obligation, to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1684">
                <li data-id="element-1685">Monitor the site for violations of these Terms of Use</li>
                <li data-id="element-1686">
                  Take appropriate legal action against anyone who violates the
                  law or these Terms of Use
                </li>
                <li data-id="element-1687">
                  Refuse, restrict access to, limit availability of, or disable
                  any of your contributions
                </li>
                <li data-id="element-1688">
                  Remove from the site or otherwise disable all files and
                  content that are excessive in size or burdensome to our
                  systems
                </li>
                <li data-id="element-1689">
                  Manage the site in a manner designed to protect our rights and
                  property and to facilitate the proper functioning of the site
                </li>
              </ul>
            </div>
          </div>

          {/* Privacy Policy */}
          <div data-id="element-1690">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1691">
              PRIVACY POLICY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1692">
              <p data-id="element-1693">
                We care about data privacy and security. Please review our
                Privacy Policy. By using the site, you agree to be bound by our
                Privacy Policy, which is incorporated into these Terms of Use.
              </p>
            </div>
          </div>

          {/* SMS Communications Terms */}
          <div data-id="element-1694">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1695">
              SMS COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1696">
              <p data-id="element-1697">
                By providing your mobile phone number and submitting a form on
                our site, you agree to the following terms governing SMS/text
                message communications:
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1698">Program Description</h3>
              <p data-id="element-1699">
                FindOnlineDegrees.org may send you autodialed and/or
                pre-recorded marketing text messages (SMS/MMS) regarding
                educational programs, follow-up inquiries, and promotional
                offers from us and our educational partners.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1700">Consent</h3>
              <p data-id="element-1701">
                By submitting your information, you expressly consent to receive
                such messages at the mobile number provided. Consent is not a
                condition of any purchase or service. Your consent is governed
                by our Privacy Policy, which is incorporated herein by
                reference.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1702">Message Frequency</h3>
              <p data-id="element-1703">
                Message frequency varies. You may receive multiple messages per
                inquiry depending on your interactions and program interests.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1704">Costs</h3>
              <p data-id="element-1705">
                Message and data rates may apply. Contact your wireless carrier
                for details about your plan.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1706">Opt-Out</h3>
              <p data-id="element-1707">
                You may opt out of SMS communications at any time by replying
                STOP to any message received. After opting out, you will receive
                a single confirmation message and no further SMS marketing
                messages will be sent unless you provide new consent.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1708">Assistance</h3>
              <p data-id="element-1709">
                For help, reply HELP to any message or contact us through the
                information provided on our website.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1710">
                No Warranty for Delivery
              </h3>
              <p data-id="element-1711">
                We do not guarantee that SMS messages will be delivered.
                Delivery is subject to effective transmission and your carrier's
                coverage and policies. We are not liable for delays or failures
                in SMS delivery.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1712">Third-Party Carriers</h3>
              <p data-id="element-1713">
                You acknowledge that SMS transmission involves third-party
                carriers over whom we have no control. Standard carrier terms
                and conditions apply.
              </p>
            </div>
          </div>

          {/* Email Communications Terms */}
          <div data-id="element-1714">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1715">
              EMAIL COMMUNICATIONS TERMS
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1716">
              <h3 className="font-bold text-lg" data-id="element-1717">Program Description</h3>
              <p data-id="element-1718">
                FindOnlineDegrees.org may send you marketing and promotional
                emails regarding educational programs, follow-up inquiries, and
                offers from us and our educational partners. Marketing emails
                are sent from contact@findonlinedegrees.org on behalf of Media
                Matchers LLC.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1719">Consent</h3>
              <p data-id="element-1720">
                By submitting your information on our site, you expressly
                consent to receive such emails at the address provided. Consent
                is not a condition of any purchase or service.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1721">Opt-Out</h3>
              <p data-id="element-1722">
                You may opt out of marketing emails at any time by clicking the
                unsubscribe link included in every marketing email. Opt-out
                requests will be honored within 10 business days. You may also
                opt out by contacting us at the address below.
              </p>

              <h3 className="font-bold text-lg mt-6" data-id="element-1723">CAN-SPAM Compliance</h3>
              <p data-id="element-1724">
                All commercial emails we send will accurately identify the
                sender, include our physical mailing address, and include a
                working unsubscribe mechanism.
              </p>
            </div>
          </div>

          {/* Term and Termination */}
          <div data-id="element-1725">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1726">
              TERM AND TERMINATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1727">
              <p data-id="element-1728">
                These Terms of Use shall remain in full force and effect while
                you use the site. We reserve the right to deny access to the
                site to anyone for any reason at any time without notice.
              </p>
              <p data-id="element-1729">
                If we terminate or suspend your access for any reason, you are
                prohibited from registering and creating a new account under
                your name or a borrowed name. We reserve the right to take
                appropriate legal action, including civil, criminal, and
                injunctive redress.
              </p>
            </div>
          </div>

          {/* Disclaimer */}
          <div data-id="element-1730">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1731">
              DISCLAIMER
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1732">
              <p data-id="element-1733">
                THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU
                AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR
                SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM
                ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE
                AND YOUR USE THEREOF.
              </p>
              <p data-id="element-1734">
                WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR
                COMPLETENESS OF THE SITE'S CONTENT OR THE CONTENT OF ANY
                WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR
                RESPONSIBILITY FOR ANY ERRORS, MISTAKES, OR INACCURACIES OF
                CONTENT AND MATERIALS.
              </p>
            </div>
          </div>

          {/* Limitations of Liability */}
          <div data-id="element-1735">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1736">
              LIMITATIONS OF LIABILITY
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1737">
              <p data-id="element-1738">
                IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE
                LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT,
                CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE
                DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR
                OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE.
              </p>
            </div>
          </div>

          {/* Indemnification */}
          <div data-id="element-1739">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1740">
              INDEMNIFICATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1741">
              <p data-id="element-1742">
                You agree to defend, indemnify, and hold us harmless, including
                our subsidiaries, affiliates, and all of our respective
                officers, agents, partners, and employees, from and against any
                loss, damage, liability, claim, or demand, including reasonable
                attorneys' fees and expenses, made by any third party due to or
                arising out of your use of the site or breach of these Terms of
                Use.
              </p>
            </div>
          </div>

          {/* Governing Law */}
          <div data-id="element-1743">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1744">
              GOVERNING LAW
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1745">
              <p data-id="element-1746">
                These Terms of Use and your use of the site are governed by and
                construed in accordance with the laws of the State of
                California, without regard to its conflict of law principles.
                Except for disputes subject to binding arbitration under the
                Dispute Resolution / Arbitration section below, you agree that
                any dispute arising out of or relating to these Terms shall be
                resolved exclusively in the state or federal courts located in
                Los Angeles County, California.
              </p>
            </div>
          </div>

          {/* Dispute Resolution / Arbitration */}
          <div data-id="element-1747">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1748">
              DISPUTE RESOLUTION / ARBITRATION
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1749">
              <p data-id="element-1750">
                Any dispute, claim, or controversy arising out of or relating to
                these Terms or your use of the site, including any claims under
                the Telephone Consumer Protection Act (TCPA), shall be resolved
                by binding individual arbitration under the rules of the
                American Arbitration Association. You waive any right to bring
                or participate in a class action lawsuit or class-wide
                arbitration. This arbitration agreement does not apply to claims
                that may be brought in small claims court.
              </p>
            </div>
          </div>

          {/* Contact Us */}
          <div data-id="element-1751">
            <h2 className="text-2xl font-bold text-[#3b82f6] mb-4" data-id="element-1752">
              CONTACT US
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-1753">
              <p data-id="element-1754">
                If you have any questions or concerns about these Terms &
                Conditions, please contact us at:
              </p>
              <p className="font-semibold" data-id="element-1755">Media Matchers LLC</p>
              <p data-id="element-1756">
                1865 Chestnut Street
                <br data-id="element-1757" />
                San Francisco, CA 94123
              </p>
              <p data-id="element-1758">
                Email:{' '}
                <a href="mailto:contact@findonlinedegrees.org" className="text-[#3b82f6] underline hover:text-blue-800" data-id="element-1759">
                  contact@findonlinedegrees.org
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}